import { Controller } from "stimulus"
import { hideTarget, showTarget } from '../../helpers/visibility'

export default class extends Controller {
  static targets = ["dropdown", "start", "end"]

  connect() {
    this.updateVisibility()
  }

  updateVisibility() {
    const value = this.dropdownTarget.value

    if(value === "custom") {
      showTarget(this.startTarget)
      showTarget(this.endTarget)
    }
    else {
      hideTarget(this.startTarget)
      hideTarget(this.endTarget)
    }
  }
}
